export default {
  'Start at': 'Empezar en',
  'Set to current time': 'Establecer a la hora actual',
  'Audio volume': 'Volumen de audio',
  'Video volume': 'Volumen de vídeo',
  'Trim audio': 'Recortar audio',
  'Audio will end with the video': 'El audio terminará con el vídeo.',
  'Trim': 'Recortar',
}